import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=3876f845&scoped=true"
import script from "./NavigationTab.vue?vue&type=script&lang=ts"
export * from "./NavigationTab.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTab.vue?vue&type=style&index=0&id=3876f845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876f845",
  null
  
)

export default component.exports